  /* eslint-disable */
export default function tempInit() {
  // /* smooth anchor scroll */ articles
  $('.smooth').on('click',function (e) {
    e.preventDefault();
    const target = this.hash;
        const $target = $(target);
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top
    }, 900, 'swing', function () {
        window.location.hash = target;
    });
  });


  //  in articles pages and some else page
  $("#toTop").click(function() {
    $("html, body").animate({scrollTop: 0}, 1000);
  });
    /* --- back-top ---*/
    $(window).scroll(function() {
      if ($(this).scrollTop()) {
          $("#toTop").fadeIn();
      } else {
          $("#toTop").fadeOut();
      }
  });




  // article, case-studies -  socials sticky

  $(function(){
    function Ascroll() {
        if (b == null) {
            const Sa = getComputedStyle(a, ''); let s = '';
            for (var i = 0; i < Sa.length; i++) {
                if (Sa[i].indexOf('overflow') == 0 || Sa[i].indexOf('padding') == 0 || Sa[i].indexOf('border') == 0 || Sa[i].indexOf('outline') == 0 || Sa[i].indexOf('box-shadow') == 0 || Sa[i].indexOf('background') == 0) {
                    s += `${Sa[i]  }: ${ Sa.getPropertyValue(Sa[i])  }; `
                }
            }
            b = document.createElement('div');
            b.style.cssText = `${s  } box-sizing: border-box; width: ${  a.offsetWidth  }px;`;
            a.insertBefore(b, a.firstChild);
            const l = a.childNodes.length;
            for (var i = 1; i < l; i++) {
                b.appendChild(a.childNodes[1]);
            }
            a.style.height = `${b.getBoundingClientRect().height  }px`;
            a.style.padding = '0';
            a.style.border = '0';
        }
        const Ra = a.getBoundingClientRect();
            const R = Math.round(Ra.top + b.getBoundingClientRect().height - document.querySelector('.article-post, .glossary-post, .article-redesign').getBoundingClientRect().bottom);  // �������� �����, ��� ���������� ������� ���� �������� ����� ��������� ����������� �������
        if ((Ra.top - P) <= 0) {
            if ((Ra.top - P) <= R) {
                b.className = 'stop';
                b.style.top = `${- R }px`;
            } else {
                b.className = 'sticky';
                b.style.top = `${P  }px`;
            }
        } else {
            b.className = '';
            b.style.top = '';
        }
        window.addEventListener('resize', function() {
            a.children[0].style.width = getComputedStyle(a, '').width
        }, false);
    }
    const a = document.querySelector('.social-main'); let b = null; const P = 200;

    if(a !== null) {
        window.addEventListener( 'scroll', Ascroll, false );
        document.body.addEventListener( 'scroll', Ascroll, false );
    }
});

}


